var React = require('react');

function Locationpin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7,0C3.1,0,0,3.1,0,7c0,5.2,7,13,7,13s7-7.8,7-13C14,3.1,10.9,0,7,0z M7,9.5C5.6,9.5,4.5,8.4,4.5,7S5.6,4.5,7,4.5\n\tS9.5,5.6,9.5,7S8.4,9.5,7,9.5z"}));
}

Locationpin.defaultProps = {"width":"14","height":"20","viewBox":"0 0 14 20"};

module.exports = Locationpin;

Locationpin.default = Locationpin;
